
































import Vue from "vue";
import { createURL, OperationResponse, updateURL } from "../../services";

function isValidURL(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (_) {
    return false;  
  }

}

const codeRegex = /^[a-zA-Z0-9-]+$/
export default Vue.extend({
  props: {
    url: Object,
    reset: {}
  },
  data: () => ({
    codeRules: [(v) => !!v || "Kurzlink muss angegeben werden", v => codeRegex.test(v) || 'Kurzlink darf nur alphanumerishe Zeichen sowie `-` enthalten'],
    targetRules: [(v) => !!v || 'Ziellink muss angebeben werden', v => isValidURL(v) || 'Ziellink muss eine gültige url sein'],
    codeErrors: [] as string[]
  }),
  watch: {
    url: {
      deep: true,
      handler: function() {
        if (this.codeErrors.length) {
          this.codeErrors = [];
        }
      }
    },
    reset: function(reset: boolean) {
      if (reset) {
        if (this.url.id) {
          (this.$refs.form as any).resetValidation();
        } else {
          (this.$refs.form as any).reset();
        }
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
      (this.$refs.form as any).reset();
    },
    async save() {
      if (!(this.$refs.form as any).validate()) {
        return;
      }
      let res: OperationResponse<any>;
      if (this.url.id) {
        res = await updateURL({
          id: this.url.id,
          target: this.url.target,
        });
      } else {
        res = await createURL({
          code: this.url.code,
          target: this.url.target
        });
      }
      if (res.success) {
        this.$emit("close", true);
        (this.$refs.form as any).reset();
      } else {
        const codeErrors = res.response.code;
        const linkErrors = res.response.target;
        if (Array.isArray(codeErrors)) {
          this.codeErrors.push(...codeErrors)
        }
        // if (Array.isArray(linkErrors)) {

        // }
      }
    },
  },
});
